import CascateList from "../../../../../../common/components/cascate_list";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DropDown } from "../../../../../../common/domain/models/dropdown";

type Props = {
  nome: string | null;
  status?: number;
  onNomeChange: (nome: string | null) => void;
  onClearFilters: () => void;
  handleStatusChange: (novoStatus: number | null) => void;
};

export const Header = ({
  nome,
  status,
  onNomeChange,
  onClearFilters,
  handleStatusChange,
}: Props) => {
  const ddlStatus: DropDown[] = [
    { id: 2, title: "Todos" },
    { id: 0, title: "Inativo" },
    { id: 1, title: "Ativo" },
  ];
 return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="w-full col-span-1 md:col-span-3">
            <DefaultInput
              name="nome"
              label="Nome de Epi"
              value={nome}
              onChangeValue={onNomeChange}
            />
          </div>
          <div className="w-full col-span-1 md:col-span-1">
            <DefaultAutocomplete
              label="Status"
              value={ddlStatus.find((x) => x.id === status) ?? null}
              options={ddlStatus}
              getOptionLabel={(x) => x.title}
              getOptionKey={(x) => x.id}
              onChange={(x) => handleStatusChange(x?.id ?? null)}
            />
          </div>
          
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={
                <DynamicIcon
                  nameIcon="ClearRounded"
                  size={25}
                  className="text-black"
                />
              }
              buttonColor="yellow"
              onClick={onClearFilters}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
